import AuroraHeader from "./AuroraHeader";
import AuroraFooter from "./AuroraFooter";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#050506] text-white flex flex-col">
      <AuroraHeader />
      <main className="flex-1 pt-16" data-testid="public-page-main">
        {children}
      </main>
      <AuroraFooter />
    </div>
  );
}
